import React from "react";
import Progress9Svg from "../../../assets/svgicons/progress-bar/progress_bar_9.svg";

const Progress9 = (props) => {
  return <img src={Progress9Svg} alt="Progress 9" {...props} />;
};

export default Progress9;
